import {useMutation} from '@tanstack/react-query';
import queryClient from '@/utils/reactQueryClient';
import brandIntegrationUpdaters, {
  buildInstagramOAuthUrl,
  buildTiktokOAuthUrl,
} from '@/api/updaters/brandIntegrations';

function useUnlinkInstagram() {
  return useMutation({
    mutationKey: ['brand', 'unlinkInstagram'],
    mutationFn: brandIntegrationUpdaters.unlinkInstagram,
    onSuccess: () => {
      queryClient.invalidateQueries(['organizationBrands']);
    },
  });
}

function useLinkShopify() {
  return useMutation({
    mutationKey: ['brand', 'linkShopify'],
    mutationFn: brandIntegrationUpdaters.linkShopify,
    onSuccess: () => {
      queryClient.invalidateQueries(['organizationBrands']);
    },
  });
}

function useUnlinkShopify() {
  return useMutation({
    mutationKey: ['brand', 'unlinkShopify'],
    mutationFn: brandIntegrationUpdaters.unlinkShopify,
    onSuccess: () => {
      queryClient.invalidateQueries(['organizationBrands']);
    },
  });
}

function useUnlinkTiktok() {
  return useMutation({
    mutationKey: ['brand', 'unlinkTiktok'],
    mutationFn: brandIntegrationUpdaters.unlinkTiktok,
    onSuccess: () => {
      queryClient.invalidateQueries(['organizationBrands']);
    },
  });
}

function linkInstagram(brandId: string, partnershipAdsEnabled = false) {
  window.location.href = buildInstagramOAuthUrl(brandId, partnershipAdsEnabled);
}

function linkTiktok(brandId: string) {
  window.location.href = buildTiktokOAuthUrl(brandId);
}

export {
  useUnlinkInstagram,
  useLinkShopify,
  useUnlinkShopify,
  useUnlinkTiktok,
  linkInstagram,
  linkTiktok,
};
